import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_DETAILS
    SET_STEP_DETAILS
    SET_IS_TRUECALLER
    SET_ACCORDION_ACTIVE_STEP_INDEX
    SET_FORM_ACTIVE_SCREEN
    RESET_PDI_LEAD_DATA
    SET_CAR_TYPE_PDI_LEAD
`,
    {
        prefix: "predeliveryinspectionleaddata/"
    }
);
